<script>
export default defineComponent({
  name: "WhatIsOperoClub",
  props: {
    setCursor: {
      required: true,
      type: Function,
    }
  },
  data() {
    return {
      data: [
        {
          icon: "/img/icon-3.svg",
          title: this.$t("membership.whatWeOffer.atmosphere"),
        },
				{
          icon: "/img/icon-12.svg",
          title: this.$t("membership.whatWeOffer.hearth"),
        },
				{
          icon: "/img/icon-13.svg",
          title: this.$t("membership.whatWeOffer.cafe"),
        },
				{
          icon: "/img/icon-4.svg",
          title: this.$t("membership.whatWeOffer.networking"),
        },
				{
          icon: "/img/icon-11.svg",
          title: this.$t("membership.whatWeOffer.meetingRooms"),
        },
        {
          icon: "/img/icon-2.svg",
          title: this.$t("membership.whatWeOffer.manager"),
        },
        {
          icon: "/img/icon-7.svg",
          title: this.$t("membership.whatWeOffer.post"),
        },
        {
          icon: "/img/icon-9.svg",
          title: this.$t("membership.whatWeOffer.events"),
        },
        
      ],
    };
  },
});
</script>

<script setup>
  function handleClick() {
    const button = document.getElementById('opero-club-form-trigger');

    button.dispatchEvent(new CustomEvent('click'));
  }
</script>

<template>
  <div class="opero-club bg-primary mt-10 pt-10 md:pt-16">
    <div class="flex justify-center">
      <div class="max-w-7xl p-6 w-full">
        <div class="opero-club-grid md:grid grid-cols-2 gap-4">
          <div class="opero-club-headline mb-8 md:mb-0">
            <div class="opero-club-headline__icon">
              <AnimationPaperMeet canvasWidth="70px" canvasHeight="70px" />
            </div>
            <h2 class="h1 whitespace-nowrap">
              {{ $t("membership.WhatIsOperoClub.title") }}
            </h2>
          </div>
          <div class="opero-club-subheading mb-10 md:mb-0">
            <p v-if="false" class="mb-2"><span class="text-2xl lg:text-3xl font-medium" v-html="$t('membership.WhatIsOperoClub.subheading')"></span></p>
            <div class="how-it-works-club">
              <h3>{{ $t("membership.HowItWorks.club.title") }}</h3>
              <p class="how-it-works-club__price">{{ $t("membership.HowItWorks.club.price") }}</p>
              <p class="how-it-works-club__copy">{{ $t("membership.HowItWorks.club.copy") }}</p>
              <div class="text-center">
                <button
                  @click="handleClick"
                  class="bg-transparent border rounded-full border-black text-lg text-black px-4 py-2 mt-6"
                >
                  {{ $t("want-to-try-it") }}
                </button>
              </div>
            </div>
          </div>
          <div v-if="false" class="opero-club-copy mb-10 md:mb-0">
            <p class="mb-5">{{ $t("membership.WhatIsOperoClub.col1.text1") }}</p>
            <p><span class="text-base">{{ $t("membership.WhatIsOperoClub.col1.text2") }}</span></p>
          </div>
          <div v-if="false" class="opero-club-copy">
            <p class="mb-5">{{ $t("membership.WhatIsOperoClub.col2.text1") }}</p>
            <p><span class="text-base">{{ $t("membership.WhatIsOperoClub.col2.text2") }}</span></p>
          </div>

          <WhatWeOffer
            class="what-we-offer"
            @mouseover="
              setCursor(null, null, {
                'font-size': '14px',
                cursor: 'unset',
                'z-index': '-1',
                width: '25px',
                height: '25px',
              })
            "
          />

          <div class="book-call gap-10 md:gap-20 m-14 mb-0">
            <div class="book-call-person">
              <img src="/img/iva-seidlova-opero-club.jpg" alt="Iva Seidlová" />
              <p><strong>Iva Seidlová</strong></p>
              <p>{{ $t('membership.HowItWorks.BookCall.person_title') }}</p>
            </div>
            <div class="book-call-copy">
              <h3>{{ $t("membership.HowItWorks.BookCall.title") }}</h3>
              <p v-html="$t('membership.HowItWorks.BookCall.copy')"></p>
              <div class="book-call-button">
                <a class="button bg-transparent border rounded-full border-black text-lg text-black px-4 py-2 mt-6" href="https://calendly.com/operoprague/15-minutovy-call-opero" target="_blank">{{ $t("membership.HowItWorks.BookCall.buttonLabel") }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .opero-club {
    &-grid {
      row-gap: 60px;
    }
    &-headline {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 40px;

      // @media all and (min-width: 768px) {
      //   grid-column: 1 / span 2;
      // }

      &__icon {
        display: block;
      }
    }

    &-subheading {
      @media all and (min-width: 768px) {
        display: flex;
        grid-column: 2;
        // grid-row: 2 / span 2;
        max-width: 350px;
        margin-left: 40px;
        align-items: center;
      }
    }

    &-copy {
      @media all and (min-width: 768px) {
        grid-column: 2;
      }

      p {
        font-weight: 400;
      }
    }
  }
  p {
    font-size: 20px;
  }

  .what-we-offer {
    grid-column: 1 / span 2;
    max-width: 900px;
    margin: 0 auto;
  }

  .how-it-works-club {
    text-align: center;
    margin-top: 40px;

    &__copy {
      font-size: 14px;
      max-width: 260px;
      margin: 0 auto !important;
    }
  }

  .book-call {
    display: grid;
    max-width: 700px;
    margin: 40px auto;
    padding-top: 40px;
    padding-bottom: 40px;
    grid-column: 1 / span 2;
    grid-template-columns: auto 1fr;
    border-top: solid 1px #000;

    @media all and (max-width: 992px) {
      grid-template-columns: 1fr 1fr;
    }

    @media all and (max-width: 640px) {
      grid-template-columns: 1fr;
    }

    &-image {
      @media all and (min-width: 640px) and (max-width: 992px) {
        grid-column: 1 / span 2;
      }
    }

    &-copy {
      display: flex;
      flex-direction: column;

      @media all and (max-width: 640px) {
        text-align: center;
        align-items: center;
      }
    }

    &-button {
      display: flex;
      flex: 1;
      align-items: flex-end;

      .button {
        @media all and (max-width: 640px) {
          margin-top: 0;
        }
      }
    }

    &-person {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 180px;
        border-radius: 50%;
        margin-bottom: 20px;
      }

      p {
        margin: 0;
      }
    }
  }
</style>